/**
 * Product Card Image Slider
 * Scroll-snap slider with dot navigation for product card images.
 * Clicking the media area navigates to the product URL.
 */
if (!customElements.get('product-card-slider')) {
  class ProductCardSlider extends HTMLElement {
    connectedCallback() {
      this.slides = this.querySelector('.cl-product-card__slides');
      this.dots = this.querySelectorAll('.cl-product-card__dot');
      if (!this.slides) return;

      if (this.dots.length > 1) this.initDots();
      this.initClickNav();
    }

    initDots() {
      this.dots.forEach((dot) => {
        dot.addEventListener('click', (e) => {
          e.stopPropagation();
          const slide = this.slides.children[parseInt(dot.dataset.index)];
          if (slide) this.slides.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        });
      });

      let ticking = false;
      this.slides.addEventListener(
        'scroll',
        () => {
          if (ticking) return;
          ticking = true;
          requestAnimationFrame(() => {
            const idx = Math.round(this.slides.scrollLeft / this.slides.offsetWidth);
            this.dots.forEach((d) =>
              d.classList.toggle('cl-product-card__dot--active', parseInt(d.dataset.index) === idx)
            );
            ticking = false;
          });
        },
        { passive: true }
      );
    }

    initClickNav() {
      let startX, startY;

      this.addEventListener('pointerdown', (e) => {
        startX = e.clientX;
        startY = e.clientY;
      });

      this.addEventListener('click', (e) => {
        if (e.target.closest('.cl-product-card__dot')) return;
        if (typeof startX === 'number' && Math.abs(e.clientX - startX) + Math.abs(e.clientY - startY) > 10) return;
        const url = this.dataset.url;
        if (url) window.location.href = url;
      });
    }
  }

  customElements.define('product-card-slider', ProductCardSlider);
}
